import { ChangePlanModule } from './changePlan.module.component';

export const LaunchChangePlanServiceModule = angular
    .module('app.components.changePlan.launchChangePlanService', [
        'ngMaterial',
        ChangePlanModule
    ]).service('launchChangePlanService', ($mdDialog) => {
        function openModal(event) {
            angular.element('body').addClass('md-dialog--container-scroll');
            $mdDialog.show({
                template: `
                    <md-dialog class="change-plan-modal">
                        <change-plan></change-plan>
                    </md-dialog>
                `,
                event: event
            }).finally(() => {
                angular.element('body').removeClass('md-dialog--container-scroll');
            });
        }

        return {
            openModal
        };
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/changePlan/launchChangePlan.service.js